// src/api/user.ts
import ApiService from "@/utils/request";
export const eamApi = {
    // 资产统计
    total: () => ApiService.get("/eam/screen/stat/total/0"),
    // 共享资产
    shareAssets: () => ApiService.get("/eam/screen/stat/totalAsset/0?limit=20"),
    // 按状态统计各部门资产
    status: () => ApiService.get("/eam/screen/stat/status/0"),
    // 按资产类别统计
    category: (params) => ApiService.get("/eam/screen/stat/category/0/" + params),
    // 按资产区域统计
    area: (url) => ApiService.get(url), // ,/uam/datav/screen/area/0/1 // /eam/screen/stat/area/0/1
    // 按项目统计
    project: () => ApiService.get("/eam/screen/stat/project/0"),
    // 使用部门分布
    dept: () => ApiService.get("/eam/screen/stat/dept/0/1"),
    // 资产趋势
    month: () => ApiService.get("/eam/screen/stat/month/6"),
    // 3D大模型资产（固定资产）
    getLocation: (params) => ApiService.get("/eam/screen/stat/getLocation", params),
};
